const SET_REUSE_FORM = 'SET_REUSE_FORM'
const RESET_REUSE_FORM = 'RESET_REUSE_FORM'

export { SET_REUSE_FORM, RESET_REUSE_FORM }
